<script>
/*jshint esversion: 6 */
export default {
    name: 'MyText',
    props: { 
        'disabled': {type: Boolean},
        'model': { type: [Object], default: function() { return {};} }, 
        'schema': { type: [Object], default: function() { return {};} }, 
        'schemaId': {type: Number, default: 0}, 
		'hinted': {type:String},
    }
};
</script>
<template lang="pug">
.vueFormFieldMain
    .freeTextMain
        .fieldMyText(:id="schema.id")
            template(v-if="schema.freeTextType === 'blank'")
                .row.gy-2.gx-3-align-items-left.freeTextBlank(:class="schema.class" )
                    .col-sm-12 
                        div(:id="schemaId")
                            span(v-html="schema.freeText") 
            template(v-if="schema.freeTextType === 'withLabel'")
                .col-sm-12(:class="schema.class")
                    .row.gx-3-align-items-left
                        .col-sm-12 
                            label(v-if="schema.label && schema.label.length > 0" v-html="schema.label")
                    .form-group.row.gx-3-align-items-left
                        .col-sm-12
                            span( v-html="schema.freeText") 
            template(v-if="schema.freeTextType === 'withModel'")    
                .row.gx-3-align-items-left(:class="schema.class")
                    .col-sm-12 
                        span(v-html="model[schema.model]") 
            template(v-if="schema.freeTextType === 'withModelLabel'")  
                .col-sm-12(:class="schema.class")
                    .row.gx-3-align-items-left
                        .col-sm-12 
                            label(v-if="schema.label && schema.label.length > 0") {{ schema.label }}
                    .form-group.row.gx-3-align-items-left
                        .col-sm-12
                            span(v-html="model[schema.model]") 
            .row.fieldInput.col-12
                .hint(v-if="hinted && hinted.length > 0" v-html="hinted")
</template>